module.exports = __webpack_public_path__ + "static/img/icon-female.66656025.png";